import {AbstractSettings} from '../abstract-settings';

export class MandelbrotSettings extends AbstractSettings {

  // FIXME Maybe littler refactor
  constructor() {
    super(100, 0, 0, 0, 0, 300);
  }
}
